import { defineStore } from 'pinia';
import { strapi } from '~/stores/transport/strapi';
import { type IStrapiImage } from '~/types/strapiImage';
import { assignDataToFields, createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import { useStoreButtonTitles } from '../buttonTitles';
import type { IModalConfirm } from '~/types/confirm';

export const useStoreModalConfirm = defineStore('modalConfirm', {
  state: () => ({
    successTitle: '',
    successMessageText: '',
    successIcon: {} as IStrapiImage,
    failTitle: '',
    failMessageText: '',
    failIcon: {} as IStrapiImage,
    locale: '',
    counter: NaN,
    counterId: NaN,
    isCounterInProcess: false,
    isPopupShown: false,
    requestPromise: null as Promise<any> | null,
  }),

  getters: {
    successData(): IModalConfirm {
      const storeButtons = useStoreButtonTitles();

      return {
        title: this.successTitle,
        messageText: this.successMessageText,
        icon: this.successIcon,
        buttonTitle: storeButtons.ok,
      };
    },

    failData(): IModalConfirm {
      const storeButtons = useStoreButtonTitles();

      return {
        title: this.failTitle,
        messageText: this.failMessageText,
        icon: this.failIcon,
        buttonTitle: storeButtons.reset,
      };
    },
  },

  actions: {
    async loadConfirmModal() {
      if (!this.requestPromise) {
        const populateString = createPopulateString(['successIcon', 'failIcon']);

        this.requestPromise = strapi()
          .get('confirm-modal', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },

    /**
     * Method that count seconds for timer
     */
    countSeconds() {
      if (import.meta.browser && window) {
        clearTimeout(this.counterId);
        if (this.counter > 0) {
          this.counter--;
          this.counterId = window.setTimeout(() => this.countSeconds(), 1000);
        } else {
          this.isCounterInProcess = false;
        }
      }
    },

    /**
     * Method for starting timer that counts seconds before
     * player can resend confirmation email
     */
    startTimer() {
      if (import.meta.browser && window) {
        clearTimeout(this.counterId);
        this.isCounterInProcess = true;
        this.counter = 60;

        this.counterId = window.setTimeout(() => this.countSeconds(), 1000);
      }
    },
    setIsCounterInProcess(value: boolean) {
      this.isCounterInProcess = value;
    },
    openPopup() {
      this.isPopupShown = true;
    },
    closePopup() {
      this.isPopupShown = false;
    },
  },
});
